import { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { ESportsbookLayoutTypes } from 'interfaces/sportsbook-configs';
import { Event, GameInfo, Market } from 'interfaces/sportsbook-data-levels';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import { getOddFormat } from 'store/selectors/betslip';
import { MatchCardBase } from '../MatchCardBase';

type Props = {
  groupedMarkets: Market[];
  teamsInfo: {
    team1: string;
    team2: string;
    startAt: number;
  };
  gameInfo?: GameInfo & {
    type: number;
  };
  sportName: string;
  competitionName: string;
  currentSport?: string;
  sport?: string;
  gameId?: number;
  isBlocked?: number;
};

export const MatchCardBaseGroup = ({
  groupedMarkets,
  teamsInfo,
  sportName,
  competitionName,
  gameInfo,
  currentSport,
  sport,
  gameId,
  isBlocked
}: Props): ReactElement => {
  const configs = useSportsbookConfigs();

  const oddFormat = useSelector(getOddFormat);

  const isUsaSinglePage =
    configs.spbLayoutType === ESportsbookLayoutTypes.AMERICAN && gameId;

  return (
    <>
      {groupedMarkets.map((market: Market) => {
        const marketCopy: Market & { event: Record<string, Event> } = {
          ...market,
          event: {}
        };

        const eventList = Object.values(market.event || {});

        if (eventList.length) {
          eventList.forEach((event: Event) => {
            marketCopy.event[event.id] = { ...event };
          });
        }

        return (
          <MatchCardBase
            sport={sport}
            gameId={gameId}
            isBlocked={isBlocked}
            key={market.id}
            market={marketCopy}
            teamsInfo={teamsInfo}
            sportName={sportName}
            competitionName={competitionName}
            gameInfo={gameInfo}
            currentSport={currentSport}
            isUsaSinglePage={!!isUsaSinglePage}
            oddFormat={oddFormat}
          />
        );
      })}
    </>
  );
};
